import {
    GET_GENRE_FILTERS_SUCCEEDED,
    GET_STATUS_FILTERS_SUCCEEDED,
    GET_TYPE_FILTERS_SUCCEEDED,
    GET_CINEMA_FILTERS_SUCCEEDED,
    GET_DISTRIBUTORS_SUCCEEDED,
    GET_CINEMA_LOCATIONS_SUCCEEDED,
    GET_STUDIOS_SUCCEEDED,
    STORE_CINEMA_LOCATION_SUCCEEDED,
    STORE_SELECTED_FESTIVAL_DATE_SUCCEEDED,
    STORE_SELECTED_EVENT_LOCATION_SUCCEEDED,
    STORE_SELECTED_MOVIE_FILTERS_SUCCEEDED,
    STORE_SELECTED_MOVIES_SORT_BY_SUCCEEDED,
    GET_SOON_IN_CINEMA_FILTERS_SUCCEEDED,
    GET_BOX_OFFICE_GENRE_FILTERS_SUCCEEDED,
    STORE_SELECTED_HOUR_SUCCEEDED,
    STORE_SELECTED_DATE_SUCCEEDED,
    REDIRECT_URL_SUCCEEDED,
} from '../actions/types';
import { defaultLocation } from '../config/config';

const initialState = {
    film_genre: [],
    film_status: [],
    film_type: [],
    film_cinema: [],
    film_distributors: [],
    film_studios: [],
    cinemaLocations: [],
    selectedCinemaLocation: defaultLocation,
    festival_details_filters: {},
    movies_filters: {},
    soonInCinemaFilters: [],
    boxOfficeFilters: [],
    movieDetailsFilters: {},
    reservetionSelectedDate: "",
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_GENRE_FILTERS_SUCCEEDED:
            return {
                ...state,
                film_genre: action.payload
            };

        case GET_STATUS_FILTERS_SUCCEEDED:
            return {
                ...state,
                film_status: action.payload
            };

        case GET_TYPE_FILTERS_SUCCEEDED:
            return {
                ...state,
                film_type: action.payload
            };

        case GET_CINEMA_FILTERS_SUCCEEDED:
            return {
                ...state,
                film_cinema: action.payload
            };
        case GET_DISTRIBUTORS_SUCCEEDED:
            return {
                ...state,
                film_distributors: action.payload
            };
        case GET_STUDIOS_SUCCEEDED:
            return {
                ...state,
                film_studios: action.payload
            };
        case GET_CINEMA_LOCATIONS_SUCCEEDED:
            return {
                ...state,
                cinemaLocations: action.payload
            }
        case STORE_CINEMA_LOCATION_SUCCEEDED:
            return {
                ...state,
                selectedCinemaLocation: action.payload
            }

        case STORE_SELECTED_FESTIVAL_DATE_SUCCEEDED:
            return {
                ...state,
                festival_details_filters: action.payload
            }
        case STORE_SELECTED_EVENT_LOCATION_SUCCEEDED:
            return {
                ...state,
                festival_details_filters: action.payload
            }
        case STORE_SELECTED_MOVIE_FILTERS_SUCCEEDED:
            return {
                ...state,
                movies_filters: action.payload
            }
        case STORE_SELECTED_MOVIES_SORT_BY_SUCCEEDED:
            return {
                ...state,
                movies_filters: action.payload
            }
        case GET_SOON_IN_CINEMA_FILTERS_SUCCEEDED:
            return {
                ...state,
                soonInCinemaFilters: action.payload
            }
        case GET_BOX_OFFICE_GENRE_FILTERS_SUCCEEDED:
            return {
                ...state,
                boxOfficeFilters: action.payload
            }
        case STORE_SELECTED_HOUR_SUCCEEDED:
            return {
                ...state,
                movieDetailsFilters: action.payload
            }
        case STORE_SELECTED_DATE_SUCCEEDED:     
            return {
                ...state,
                reservetionSelectedDate: action.payload
            }
        case REDIRECT_URL_SUCCEEDED:
            return {
                ...state,
                redirectUrl: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/SHARED/reducers/filters.reducer.js